import { longDate, monthIndex, monthLong } from '@/shared/lib';
import type { SubscriptionDetail } from '../api/types';

/** Label/value pairs of the drawer's details list. */
export function subscriptionDetails(a: SubscriptionDetail): [string, string][] {
  return [
    [a.offer === 'Enterprise' ? 'Contract ID' : 'Stripe customer', a.customerId || '—'],
    ['Country', a.country || a.domain || '—'],
    ['Base plan', a.basePlan],
    ['Customizations', a.customizations],
    [
      'User limit',
      a.userLimit ? `${a.userLimit} users` : a.offer === 'Enterprise' ? 'Contract' : '—',
    ],
    ['Started', longDate(a.started)],
    [
      a.nextLabel,
      a.nextLabel === 'Ended' && a.nextValue
        ? monthLong(monthIndex(a.nextValue))
        : longDate(a.nextValue),
    ],
  ];
}
